module.exports = __webpack_public_path__ + "img/Support.b2911d6f.png";